// extracted by mini-css-extract-plugin
export default {"container":"Label_container__Ml2+o","label":"Label_label__2il9+","required":"Label_required__KhQgh","tooltipContainer":"Label_tooltipContainer__wsDop"};